import { Box, HeadingText, Icon } from "@leagueplatform/genesis-core";
import { CONTENT_MAX_WIDTH } from "@leagueplatform/web-common-components";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  onBack?: () => void;
  backLabel?: string;
  contentMaxWidth?: string;
};

export const PageHero = ({
  title,
  onBack,
  backLabel,
  contentMaxWidth,
}: Props) => {
  const navigate = useNavigate();
  const handleBack = onBack ?? (() => navigate(-1));

  return (
    <Box
      as="header"
      css={{
        backgroundColor: "$surfaceBackgroundTertiary",
        // Matches the 140px used by the SDK's PageHeaderBackground on
        // sibling pages so hero heights line up across the app.
        minHeight: "140px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        css={{
          maxWidth: contentMaxWidth ?? CONTENT_MAX_WIDTH,
          boxSizing: "content-box",
          width: "100%",
          marginInline: "auto",
          paddingInline: "$two",
          "@mobile": {
            paddingInline: "$oneAndHalf",
          },
          display: "flex",
          alignItems: "center",
          gap: "$one",
        }}
      >
        <Box
          as="button"
          type="button"
          onClick={handleBack}
          aria-label={backLabel ?? "Back"}
          css={{
            background: "transparent",
            border: "none",
            padding: "$half",
            marginInlineStart: "-$half",
            cursor: "pointer",
            borderRadius: "$circle",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "$interactiveBackgroundHovered",
            },
          }}
        >
          <Icon icon="interfaceArrowLeft" size="$oneAndHalf" />
        </Box>
        <HeadingText level="1" size="xl">
          {title}
        </HeadingText>
      </Box>
    </Box>
  );
};
